export default class Param {
    constructor(){

        this.root = "https://www.blaze-inc.co.jp/";
        // this.root = "https://blaze-corp.details.co.jp/";
        // this.root = "http://192.168.0.68/client/blaze/git/public/";
        // this.root = "http://localhost:3000/";

        this.breakpoint = 750;
        this.displayType = ( window.innerWidth>this.breakpoint)?"pc":"sp";

        this.youtube = {
            domID : "p-movie-view-yt",
            id    : "s-jP9UQh_Vc"
        };

        this.webgl = {
            mainvisual : {
                mask : {
                    srcTrans : [
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min-trans_random_1.png":this.root+"assets/img/sp/mask-x-min-trans_random_1.png",
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min-trans_random_2.png":this.root+"assets/img/sp/mask-x-min-trans_random_2.png",
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min-trans_random_3.png":this.root+"assets/img/sp/mask-x-min-trans_random_3.png",
                    ],
                    src : [
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min_random_1.png":this.root+"assets/img/sp/mask-x-min_random_1.png",
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min_random_2.png":this.root+"assets/img/sp/mask-x-min_random_2.png",
                        !Useragnt.mobile? this.root+"assets/img/top/mask-x-min_random_3.png":this.root+"assets/img/sp/mask-x-min_random_3.png",
                    ],
                    srcY : this.root+"assets/img/top/mask_y.png"
                },
                scene:{
                    0 : {
                        src : !Useragnt.mobile?this.root+"assets/video/mainvisual.mp4?1":Useragnt.android?this.root+"assets/video/mainvisual_sp-min.webm":this.root+"assets/video/mainvisual_sp-min.mp4",
                        thum : !Useragnt.mobile?this.root+"assets/img/top/b-kv-mv-thum.jpg":this.root+"assets/img/sp/b-kv-mv-thum.jpg?1",
                        type : "video",
                    },
                    1 : {
                        src : !Useragnt.mobile? this.root+"assets/img/top/b-vision_bg.jpg?2":this.root+"assets/img/sp/b-vision_bg.jpg?2",
                        type : "texture",
                    },
                    2 : {
                        src : !Useragnt.mobile? this.root+"assets/img/top/b-action_bg.jpg":this.root+"assets/img/sp/b-action_bg.jpg",
                        type : "texture",
                    },
                    // 3 : {
                    //     // src : this.root+"assets/img/top/b-products_bg01.jpg",
                    //     src : [
                    //         !Useragnt.mobile? this.root+"assets/img/top/b-products_bg01.jpg":this.root+"assets/img/sp/b-products_bg01.jpg",
                    //         !Useragnt.mobile? this.root+"assets/img/top/b-products_bg02.jpg":this.root+"assets/img/sp/b-products_bg02.jpg",
                    //         !Useragnt.mobile? this.root+"assets/img/top/b-products_bg03.jpg":this.root+"assets/img/sp/b-products_bg03.jpg",
                    //     ],
                    //     type : "texture",
                    // },
                    3 : {
                        src : this.root+"assets/img/top/b-about_bg_2.jpg",
                        type : "texture",
                    },
                },
            },
        }
    }
}
